import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d105e57"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-m-auto p-pt-6" }, "Cover Image", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-d-flex p-justify-center" }, "Select a cover image for your campaign", -1))
const _hoisted_3 = { class: "p-d-flex p-justify-center p-flex-wrap p-grid" }
const _hoisted_4 = {
  key: 0,
  class: "main-photo p-col-4"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "main-photo p-col-4"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/defaultLogoCampaign.png",
  class: "main-photo-img",
  alt: "Campaign logo"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "p-d-flex p-flex-column p-col-8" }
const _hoisted_10 = { class: "p-d-flex p-flex-wrap" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src", "onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "upload-photo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "upload-photo" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "crosshair-line" }),
    /*#__PURE__*/_createElementVNode("span", { class: "cover-text" }, "Upload cover")
  ])
], -1))
const _hoisted_14 = { class: "p-d-flex p-justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cropper_image = _resolveComponent("cropper-image")!
  const _component_SecretTip = _resolveComponent("SecretTip")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return ($props.showChangeLogoModal)
    ? (_openBlock(), _createBlock(_component_Dialog, {
        key: 0,
        closable: false,
        visible: $setup.showModal,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (($setup.showModal) = $event)),
        style: { width: '75vw' },
        modal: true
      }, {
        header: _withCtx(() => [
          _hoisted_1
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Button, {
              class: "cancel-button",
              label: "CANCEL",
              onClick: $setup.closeModal
            }, null, 8, ["onClick"]),
            _createElementVNode("div", null, [
              _createVNode(_component_Button, {
                class: "change-campaign-button",
                label: "Crop image",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.showCrop = true))
              }),
              _createVNode(_component_Button, {
                class: "change-campaign-button",
                label: "Save changes",
                onClick: $setup.saveChanges
              }, null, 8, ["onClick"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_2,
          _createElementVNode("section", _hoisted_3, [
            ($setup.activeIndex >= 0 && !$setup.activeDefault)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: $setup.allPhotos[$setup.activeIndex],
                    class: "main-photo-img",
                    alt: "Campaign logo"
                  }, null, 8, _hoisted_5)
                ]))
              : ($setup.activeDefault)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                : _createCommentVNode("", true),
            _createVNode(_component_cropper_image, {
              "show-crop": $setup.showCrop,
              "onUpdate:showCrop": _cache[0] || (_cache[0] = ($event: any) => (($setup.showCrop) = $event)),
              image: $setup.allPhotos[$setup.activeIndex],
              onChange: $setup.cropMainImage
            }, null, 8, ["show-crop", "image", "onChange"]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    src: "/images/defaultLogoCampaign.png",
                    alt: "Campaign logo",
                    class: _normalizeClass(["photos", [$setup.activeDefault ? 'active-photo' : '']]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => {$setup.activeDefault = true; $setup.activeIndex = false;})
                  }, null, 2)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.allPhotos, (photo, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "p-d-flex p-flex-wrap p-mb-3 relative-block"
                  }, [
                    _createElementVNode("span", {
                      class: "delete-icon",
                      onClick: ($event: any) => ($setup.removePhoto(index))
                    }, "x", 8, _hoisted_11),
                    _createElementVNode("img", {
                      src: photo,
                      alt: "Campaign logo",
                      class: _normalizeClass(["photos", [$setup.activeIndex === index ? 'active-photo' : '']]),
                      onClick: ($event: any) => ($setup.activePreview(index))
                    }, null, 10, _hoisted_12)
                  ]))
                }), 128)),
                _createElementVNode("input", {
                  type: "file",
                  name: "photo",
                  id: "upload-photo",
                  accept: "image/*",
                  ref: "uploadPhotoInput",
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.changeCampaignPfoto && $setup.changeCampaignPfoto(...args)))
                }, null, 544),
                _hoisted_13
              ]),
              _createVNode(_component_SecretTip, { text: 'Upload a nice image for your content to make it more wanted' })
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]))
    : _createCommentVNode("", true)
}